import { createReducer } from '../utils';

const initialState = {
  serverOffset: 0,
};

/* Actions */
const HEARTBEAT_RECIEVED = 'bamboo-developments/heartbeat/RECEIVED';

/* Action creators */
export function heartbeatRecieved(data) {
  return {
    type: HEARTBEAT_RECIEVED,
    payload: {
      serverTime: data.serverTime,
    },
  };
}

/* Reducers */
export default createReducer(initialState, {
  [HEARTBEAT_RECIEVED]: (state, { serverTime }) => ({
    ...state,
    serverOffset: serverTime - new Date().getTime(),
  }),
});



// WEBPACK FOOTER //
// ./src/redux/heartbeat.js